import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class SharedStateService {
    private isHaveUnreadNotificationStateSubject = new BehaviorSubject<boolean>(false);
    isHaveUnreadNotificationState$ = this.isHaveUnreadNotificationStateSubject.asObservable();

    setIsHaveUnreadNotificationState(value: boolean) {
        this.isHaveUnreadNotificationStateSubject.next(value);
    }
}